interface CourseRequestsToolbarButtonProps {
  onClick: () => void;
}

/**
 * Header toolbar button that opens the standalone "Upload Course Requests"
 * dialog. Visually mirrors {@link RoomsToolbarButton} and
 * {@link SubjectsToolbarButton} so the toolbar reads as a single row of
 * equivalent actions. The schedule home page is responsible for gating this
 * on the OrgAdmin+ role; the button itself is presentation-only.
 */
export function CourseRequestsToolbarButton({
  onClick,
}: CourseRequestsToolbarButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="schedule-course-requests-button"
      aria-label="Upload Course Requests"
      className="bg-surface-2 text-text-soft rounded-md px-3 py-1.5 font-medium text-[13px] cursor-pointer flex items-center gap-1.5 hover:bg-surface-2/80"
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        {/* Heroicons-style document-with-arrow-up shape */}
        <path d="M9 13v6m0 0 3-3m-3 3-3-3" />
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" />
        <path d="M14 2v6h6" />
      </svg>
      Course Requests
    </button>
  );
}
